import React, { Fragment } from "react";
import { PanelHeader } from "../Panel";
import { DateRangeConfig } from "./config";
import DateFilter from "./DateFilter";

export function Filter({
  name,
  title,
  options,
  value,
  onChange,
  isDateRangeFilter = false,
  isAdvanceDateFilter,
  hasSearched,
}) {
  let date = value;
  if (isDateRangeFilter && (!value.startDate || !value.endDate)) {
    date = DateRangeConfig.DEFAULT_DATERANGE;
  }
  return (
    <Fragment>
      <PanelHeader title={title} />
      <div className="panel-body">
        {isDateRangeFilter ? (
          <DateFilter
            isAdvanceDateFilter={isAdvanceDateFilter}
            hasSearched={hasSearched}
            startDate={date.startDate}
            endDate={date.endDate}
            onChange={onChange}
          />
        ) : (
          <select
            className="form-control"
            name={name}
            value={value}
            onChange={onChange}
          >
            {options &&
              options.map((option, index) => (
                <option key={index} value={option.id}>
                  {option.name}
                </option>
              ))}
          </select>
        )}
      </div>
    </Fragment>
  );
}
